export default [
  {
    // 个人中心
    path: '/personalCenter',
    name: 'personalCenter',
    component: () => import('@/pages/personalCenter/personalCenter.vue'),
    // redirect: '/personalCenter/setting',
    redirect: '/personalCenter/returnClass',
    children: [
      {
        path: 'Index',
        component: () => import('@/pages/personalCenter/personageIndex/personageIndex.vue'), // 个人中心列表页
        meta: {
          // requireAuth: true,
        },
      },
      // 个人设置
      {
        path: 'setting',
        name: 'setting',
        component: () => import('@/pages/personalCenter/personageSetting/personage.vue'),
      },
      // 地址管理11/9
      {
        path: 'address',
        name: 'address',
        component: () => import('@/pages/personalCenter/addressAdministration/newAdressChange.vue'),
        meta: {
          title: '地址管理',
          isUseCache: false, // 默认不缓存
          keepAlive: true,
          requireAuth: true,
        },
      },
      // 地址管理
      // {
      //   path: 'address',
      //   name: 'address',
      //   component: () => import('@/pages/personalCenter/addressAdministration/addressAdministration.vue'),
      //   meta: {
      //     title: '地址管理',
      //     isUseCache: false, // 默认不缓存
      //     keepAlive: true,
      //     requireAuth: true,
      //   },
      // },
      // 我的订单
      {
        path: 'myIndent',
        name: 'myIndent',
        component: () => import('@/pages/personalCenter/myIndent/myIndent.vue'),
        meta: {
          title: '我的订单',
          // requireAuth: true,
        },
      },
      {
        path: 'myHandsel',
        name: 'myHandsel',
        component: () => import('@/pages/personalCenter/myHandsel/myHandsel.vue'),
        meta: {
          title: '我的定金',
          requireAuth: true,
        },
      },
      {
        path: 'handselDetail',
        name: 'handselDetail',
        component: () => import('@/pages/personalCenter/myHandsel/handselDetail.vue'),
        meta: {
          title: '定金详情',
          requireAuth: true,
        },
      },
      // 我的快递
      {
        path: 'myExpress',
        name: 'myExpress',
        component: () => import('@/pages/personalCenter/logistics/myExpress.vue'),
        meta: {
          title: '我的快递',
          requireAuth: true,
        },
      },
      // 我的物流
      {
        path: 'logistics',
        name: 'logistics',
        component: () => import('@/pages/personalCenter/logistics/logistics.vue'),
        meta: {
          title: '快递列表',
          requireAuth: true,
        },
      },
      // 我的活动
      {
        path: 'myActivity/:tab?',
        name: 'myActivity',
        component: () => import('@/pages/personalCenter/myActivity/MyActivity.vue'),
        meta: {
          title: '我的活动',
          requireAuth: true,
        },
      },
      // 退换课
      {
        path: 'returnClass',
        name: 'returnClass',
        component: () => import('@/pages/personalCenter/returnClass/returnClass.vue'),
        meta: {
          title: '课程升级',
          requireAuth: true,
        },
      },
      {
        path: 'myCoupon',
        component: () => import('@/pages/personalCenter/myCoupon/myCoupon.vue'),
        meta: {
          title: '优惠券'
        },
      },
      {
        path: 'mycourseList',
        component: () => import('@/pages/personalCenter/myCourse/myCourse.vue'),
        meta: {
          title: '我的课程',
          requireAuth: true,
        },
      },
      {
        path: 'overdueCourses',
        component: () => import('@/pages/personalCenter/overdueCourses/overdueCourses.vue'),
        meta: {
          title: '过期课程',
          requireAuth: true,
        },
      },
      {
        path: 'courseTmall',
        component: () => import('@/pages/personalCenter/courseTmall/courseTmall.vue'),
        // component: () => import('@/pages/personalCenter/courseTmall/defaultPage.vue'),
        meta: {
          title: '激活中心',
          requireAuth: true,
        },
      },
      {
        path: 'ytCourseTmall',
        component: () => import('@/pages/personalCenter/ytCourseTmall/courseTmall.vue'),
        // component: () => import('@/pages/personalCenter/courseTmall/defaultPage.vue'),
        meta: {
          title: '激活中心',
          requireAuth: true,
        },
      },
      {
        path: 'zsbCourseTmall',
        component: () => import('@/pages/personalCenter/zsbCourseTmall/courseTmall.vue'),
        // component: () => import('@/pages/personalCenter/courseTmall/defaultPage.vue'),
        meta: {
          title: '激活中心',
        },
      },
      // {
      //   path: 'courseTmall',
      //   // component: () => import('@/pages/personalCenter/courseTmall/courseTmall.vue'),
      //   component: () => import('@/pages/personalCenter/courseTmall/defaultPage.vue'),
      //   meta: {
      //     title: '课程激活',
      //     requireAuth: true,
      //   },
      // },
      // 我的协议
      {
        path: 'myAgreement',
        component: () => import('@/pages/personalCenter/myAgreement/agreementList.vue'),
        meta: {
          title: '我的协议',
          requireAuth: true,
        },
      },
      // 帮助中心
      {
        path: 'helpCenter',
        component: () => import('@/pages/personalCenter/helpCenter/helpCenter.vue'),
        meta: {
          title: '帮助中心',
          requireAuth: false,
        },
      },
      {
        // 会员中心
        path: 'member',
        component: () => import('@/pages/personalCenter/member/index.vue'),
        meta: {
          title: '会员中心',
        },
      },
      {
        // 会员中心
        path: 'benefits',
        component: () => import('@/pages/personalCenter/memberBenefits/index.vue'),
        meta: {
          title: '会员权益',
        },
      },
      {
        // 会员中心
        path: 'seniorMember',
        component: () => import('@/pages/personalCenter/memberSenior/index.vue'),
        meta: {
          title: '研力特权卡',
        },
      },
    ],
  },
  // {
  //   path: '/newAdress',
  //   name: 'newAdress',
  //   component: () => import('@/pages/personalCenter/addressAdministration/newAdressCopy.vue'),
  //   meta: {
  //     title: '新增收货地址',
  //     requireAuth: true,
  //   },
  // },

  {
    // 订单详情
    path: '/indentDetail',
    name: 'indentDetail',
    component: () => import('@/pages/personalCenter/myIndent/indentDetail/indentDetail.vue'),
    meta: {
      title: '订单详情',
      requireAuth: true,
    },
  },
  // 退换课详情页
  {
    path: '/replaceClassDetail',
    name: 'replaceClassDetail',
    component: () => import('@/pages/personalCenter/returnClass/replaceClass/replaceClassDetail.vue'),
    meta: {
      title: '换课详情',
      requireAuth: true,
    },
  },
  {
    path: '/exitClassDetail',
    name: 'exitClassDetail',
    component: () => import('@/pages/personalCenter/returnClass/exitClass/exitClassDetail.vue'),
    meta: {
      title: '退课详情',
      requireAuth: true,
    },
  },
  {
    path: '/shippedOrder/:tab?',
    name: 'shippedOrder',
    component: () => import('@/pages/personalCenter/myIndent/shippedOrder/shippedOrder.vue'),
    meta: {
      title: '物流详情',
      requireAuth: true,
    },
  },

  {
    // 协议详情
    path: '/agreementDetail',
    name: 'agreementDetail',
    component: () => import('@/pages/personalCenter/myAgreement/agreementDetail.vue'),
    meta: {
      title: '协议',
      requireAuth: true,
    },
  },
  {
    // 重读协议
    path: '/readApplication',
    name: 'readApplication',
    component: () => import('@/pages/personalCenter/myAgreement/readApplication.vue'),
    meta: {
      title: '重读协议',
      requireAuth: true,
    },
  },
  {
    // 帮助详情
    path: '/guidiance',
    name: 'guidiance',
    component: () => import('@/pages/personalCenter/helpCenter/guidiance.vue'),
    meta: {
      title: '问题详情',
      requireAuth: false,
    },
  },
  // 我的学习报告
  {
    path: '/personalReport',
    name: 'personalReport',
    component: () => import('@/pages/personalCenter/personalReport/studyReport.vue'),
    meta: {
      title: '学习报告',
      requireAuth: true,
    },
  },
  {
    // 退货物流returnExpress
    path: '/returnExpress',
    name: 'returnExpress',
    component: () => import('@/pages/personalCenter/returnExpress/index.vue'),
    meta: {
      title: '退货物流',
      requireAuth: false,
    },
  },
   // 我的学习报告
   {
    path: '/weekReport',
    name: 'learnweekReport',
    component: () => import('@/pages/personalCenter/learnweekReport/reportList.vue'),
    meta: {
      title: '学习周报',
      requireAuth: true,
    },
  },
  {
    path: '/weekReport/detail',
    name: 'detail',
    component: () => import('@/pages/personalCenter/learnweekReport/reportDetail.vue'),
    meta: {
      title: '学习周报',
      requireAuth: true,
    },
  },
  {
    path: '/orderBili',
    component: () => import('@/pages/personalCenter/orderBili/index.vue'),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/biliEditAddress',
    component: () => import('@/pages/personalCenter/orderBili/editAddress.vue'),
    meta: {
      requireAuth: true,
    },
  },
];
